import * as React from "react";

import { Link } from "react-router-dom";

import { Box } from "@mui/system";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import { Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DialogTitle from "@mui/material/DialogTitle";

import { Loader } from "./loader";
import CallUsNow from "./CallUsNow";
import Info from "../../assets/icons/info.png";
import Error from "../../assets/icons/error.png";
import Success from "../../assets/icons/success.png";
import Warning from "../../assets/icons/warning.png";
import { useContactPopover } from "./useContactPopover";
import help_center from "../../assets/icons/help_center.svg";
import StatusModal from "./customDesignedComponents/StatusModal";

import "./common.scss";

// Map AlertDialog type to StatusModal variant (success | error | warning | info)
const typeToVariant = {
  Success: "success",
  Error: "error",
  Timeout: "error",
  Warning: "warning",
  Info: "info",
  Help: "info",
  Attention: "info",
};

export default function AlertDialog({
  openPopup,
  setOpenPopup,
  mesage,
  onClose,
  width,
  type,
  buttons,
  loader,
  onCloseFun,
  exclamationMark = true,
  footer = true,
  title,
  isPadding = true,
  hideButtondiv = true,
  isTailwindComponent = false,
}) {
  const [open, setOpen] = React.useState(openPopup);
  const { handleClick: handleContactClick, ContactPopover } =
    useContactPopover();

  React.useEffect(() => {
    setOpen(openPopup);
  }, [openPopup]);

  const handleClose = () => {
    setOpen(false);
    onCloseFun();
  };

  if (isTailwindComponent) {
    const variant = typeToVariant[type];
    const primaryButtonLabel =
      type === "Error"
        ? "OK, CLOSE"
        : type === "Timeout"
          ? "TRY AGAIN"
          : "OK, ALL GOOD";

    const contactSupportBlock = footer ? (
      <p className="text-muted-foreground text-sm flex items-center justify-center gap-2">
        <span>Having trouble?</span>
        <button
          type="button"
          onClick={handleContactClick}
          className="text-secondary hover:text-secondary/80 font-medium bg-transparent border-0 p-0 cursor-pointer"
        >
          Contact support
        </button>
      </p>
    ) : null;

    const statusModalFooter = contactSupportBlock ?? undefined;

    return (
      <>
        <StatusModal
          open={open}
          onOpenChange={(isOpen) => {
            if (!isOpen) handleClose();
          }}
          variant={variant}
          title={title || type}
          message={mesage}
          customActions={
            buttons ? (
              <div className="flex justify-center gap-3 plain-alert-message">
                {buttons}
              </div>
            ) : undefined
          }
          primaryButtonLabel={
            hideButtondiv && onClose && !buttons
              ? primaryButtonLabel
              : undefined
          }
          onPrimaryAction={
            hideButtondiv && onClose && !buttons ? handleClose : undefined
          }
          footer={statusModalFooter}
          forcePrimaryActionOnly={!onClose}
          width={width}
        />
        <ContactPopover />
        {loader && <Loader open={loader} zIndex={130000004} />}
      </>
    );
  }

  return (
    <Dialog
      maxWidth={width ? width : "sm"}
      sx={{ zIndex: "13000001", textAlign: "center" }}
      fullWidth={true}
      open={open}
      onClose={onClose ? handleClose : null}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {onClose && (
        <Button
          onClick={handleClose}
          className="modal-close-btn"
          style={{
            position: "absolute",
            right: 10,
            top: 15,
            background: "transparent",
          }}
        >
          <CloseIcon sx={{ color: "#9CB8A6" }} />
        </Button>
      )}
      <DialogTitle id="alert-dialog-title" className="my-2">
        {type === "Success" && (
          <img className="popup_icon" src={Success} alt={type} />
        )}
        {type === "Error" && (
          <img className="popup_icon" src={Error} alt={type} />
        )}
        {type === "Info" && (
          <img className="popup_icon" src={Info} alt={type} />
        )}
        {type === "Help" && (
          <img className="popup_icon" src={Info} alt={type} />
        )}
        {type === "Attention" && (
          <img className="popup_icon" src={Info} alt={type} />
        )}
        {type === "Warning" && (
          <img className="popup_icon" src={Warning} alt={type} />
        )}

        <p className="text-center fw-600 m-0 my-2">
          {title ? title : type} {/*{exclamationMark && "!!"} */}
        </p>
        <Typography className="text-center fw-400 m-0 ">{mesage}</Typography>
      </DialogTitle>
      {hideButtondiv && (
        <Box className="mb-4 alert-modal-btn">
          {onClose &&
            !buttons &&
            (type === "Error" ? (
              <Button
                className="popup_Btn error_popup_btn "
                onClick={handleClose}
              >
                ok, Close
              </Button>
            ) : type === "Timeout" ? (
              <Button
                className="popup_Btn error_popup_btn"
                onClick={handleClose}
              >
                Try Again
              </Button>
            ) : (
              <Button
                className="popup_Btn success_popup_btn"
                onClick={handleClose}
              >
                ok, All Good
              </Button>
            ))}
          {buttons && buttons}
        </Box>
      )}

      {footer && (
        <>
          <hr />
          <Stack direction={"row"} justifyContent="center" padding={2}>
            <img src={help_center} alt="help_center" className="me-1" />
            <span className="me-1">Having trouble?</span>
            <CallUsNow
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              renderText={
                <Link className="text-blue text-decoration-none" to="">
                  Contact support
                </Link>
              }
            />{" "}
          </Stack>
        </>
      )}
      {loader && <Loader open={loader} zIndex={130000004} />}
    </Dialog>
  );
}
